module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2 remove"
  }, [_c('label', {
    attrs: {
      "for": "noofprint"
    }
  }, [_vm._v("Number of QR:")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "noofprint"
    },
    model: {
      value: (_vm.noToPrintqr),
      callback: function($$v) {
        _vm.noToPrintqr = $$v
      },
      expression: "noToPrintqr"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5 remove"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "label": "Print"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setArraylength.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4 p-mt-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-secondary btn",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generateQR.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger btn",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.back()
      }
    }
  })], 1)]), _vm._v(" "), _c('Card', {
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, _vm._l((_vm.testArray), function(itm) {
          return _c('div', {
            staticStyle: {
              "margin-top": "-3"
            }
          }, [_c('barcode', {
            attrs: {
              "value": _vm.value
            }
          })], 1)
        }), 0)]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a7dbf26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/commonDialogs/QrCode.vue
// module id = 2334
// module chunks = 0